import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { AppSidebar } from '@/components/layout/app-sidebar'
import { SiteHeader } from '@/components/layout/site-header'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { isAdminUser, isOrganisationAdminUser } from '@/lib/role-guards'
import { checkSupervisorAccess } from '@/lib/supervisor-access'

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
  beforeLoad: async ({ context, location }) => {
    // If authentication is still being determined, defer auth checks for now.
    if (context.auth.isLoading) {
      return
    }

    if (!context.auth.isAuthenticated) {
      // If this transition comes immediately after an intentional logout,
      // avoid appending a redirect back to the protected page.
      if (typeof window !== 'undefined') {
        const justLoggedOut = window.sessionStorage.getItem('justLoggedOut')
        if (justLoggedOut) {
          try {
            window.sessionStorage.removeItem('justLoggedOut')
          }
          catch {}
          throw redirect({ to: '/login', search: {} })
        }
      }
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }

    if (
      location.pathname.startsWith('/leave/config')
      && !isAdminUser(context.auth.user)
      && !isOrganisationAdminUser(context.auth.user)
    ) {
      throw redirect({ to: '/access-denied' })
    }

    if (location.pathname.startsWith('/leave/approvals')) {
      const hasSupervisorAccess = await checkSupervisorAccess()
      if (!hasSupervisorAccess) {
        throw redirect({ to: '/access-denied' })
      }
    }
  },
})

function RouteComponent() {
  return (
    <SidebarProvider>
      {/* Keep inset variant so SidebarInset applies margins and prevents overlap */}
      <AppSidebar />
      <SidebarInset>
        <SiteHeader />
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col gap-2">
            <div className="flex flex-col gap-4 p-4 md:gap-6 md:p-6">
              <Outlet />
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
